// One-shot per-tab lead source override. Blog inline CTAs set this before
// opening a shared modal / navigating to a shared form so the resulting
// Supabase insert can be attributed to the exact post + magnet.
//
// Usage:
//   setLeadSourceOverride("blog_inline_stronger_semi-private-personal-training-woodstock");
//   ...later, inside the modal/form submit handler:
//   const source = consumeLeadSourceOverride() ?? "stronger_7day_popup";

const KEY = "hive-lead-source-override";

export const setLeadSourceOverride = (source: string) => {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(KEY, source);
  } catch {
    /* ignore */
  }
};

export const consumeLeadSourceOverride = (): string | null => {
  if (typeof window === "undefined") return null;
  try {
    const v = window.sessionStorage.getItem(KEY);
    if (v) window.sessionStorage.removeItem(KEY);
    return v;
  } catch {
    return null;
  }
};
